/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";

import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import useIdentityQueueEndpoints from "@/composables/api/useIdentityQueueEndpoints";
import {
  capitaliseFirstChar,
  isValueString,
} from "@/composables/helpers/useStringHelpers";

const { getPendingIdentityDocuments } = useIdentityQueueEndpoints();

// map centry names to app routes
const IDENTITY_MAPPING_ROUTES = {
  BANXA: new Map([
    ["PERSONAL_DETAILS", "/identity/identityConfirmation"],
    ["POA", "/identity/proofOfAddress"],
    ["SOURCE_FUNDS", "/identity/sourceOfFunds"],
    ["PURPOSE_OF_TX", "/identity/purposeOfTransaction"],
    ["SOF_DOCUMENT", "/identity/sofDocumentUpload"],
    // todo: route this to /identity/idUpload/nationalDriversLicence
    ["DOCUMENT", "/identity/nationalDriversLicence"],
    ["SELFIE", "/identity/selfie"],
    ["CC_SELFIE", "/identity/selfie/cc"],
    ["OCCUPATION", "/identity/occupation"],
    ["PEP_SOURCE_FUNDS", "/identity/pepSourceOfFunds"],
    ["US_TAX_ID", "/identity/ssn"], // Added SSN form for PrimeTrust
    ["DLOCAL_CPF", "/identity/dlocal/cpf"],
    ["DLOCAL_SAID", "/identity/dlocal/said"],
    ["DLOCAL_CURP", "/identity/dlocal/curp"],
    ["DLOCAL_DNI", "/identity/dlocal/dni"],
    ["DLOCAL_CC", "/identity/dlocal/cc"],
    ["DLOCAL_CI", "/identity/dlocal/ci"],
    ["DLOCAL_TIC", "/identity/dlocal/tic"],
    ["DOCUMENT_NUMBER", "/identity/document-number"],
  ]),
  SUMSUB: new Map([
    ["PERSONAL_DETAILS", "/identity/sumsub"],
    ["POA", "/identity/sumsub"],
    ["SOURCE_FUNDS", "/identity/sumsub"],
    ["PURPOSE_OF_TX", "/identity/sumsub"],
    ["SOF_DOCUMENT", "/identity/sumsub"],
    ["DOCUMENT", "/identity/sumsub"],
    ["SELFIE", "/identity/sumsub"],
  ]),
  // ONFIDO: new Map(["SELFIE", "/identity/onfido"], []), // todo screen
};

export const useIdentityQueueStore = defineStore({
  id: "identityQueue",
  state: () => ({
    identityRoutes: [],
  }),
  actions: {
    async fetchIdentityDocuments() {
      const { data } = await getPendingIdentityDocuments();
      if (!data) {
        return false;
      }

      const routes = [];
      Object.entries(data).forEach(([key, value]) => {
        if (isValueString(value)) {
          const provider = value.toUpperCase();
          if (
            !Object.getOwnPropertyDescriptor(IDENTITY_MAPPING_ROUTES, provider)
          ) {
            console.error(`Wrong provider: ${provider} for identity`);
            return;
          }

          if (!IDENTITY_MAPPING_ROUTES[provider].has(key)) {
            console.error(`Identity: ${key} has no mapped route for send to`);
            return;
          }

          const url = IDENTITY_MAPPING_ROUTES[provider].get(key);
          routes.push({ url, provider });
        } else {
          console.error("KYC Provider value is not returned");
        }
      });

      this.identityRoutes = routes;
      return true;
    },
    removeFirstRouteAfterNavigation() {
      this.identityRoutes.shift();
    },
    removeSumsubItems() {
      if (this.identityRoutes && this.identityRoutes.length >= 0) {
        this.identityRoutes = this.identityRoutes.filter(
          (identityDocument) =>
            identityDocument.provider.toLowerCase() !== "sumsub"
        );
      }
    },
  },
  getters: {
    getNextIdentityRoute() {
      const orderStore = useOrderFormStore();
      const defaultPaymentRoute = `/payment/${orderStore.getActivePaymentByMode}`;

      if (
        orderStore.getActivePaymentByMode &&
        this.identityRoutes.length <= 0
      ) {
        return defaultPaymentRoute;
      }

      return this.identityRoutes[0].url;
    },
  },
});
